export default __webpack_public_path__ + "static/media/AllProductShare.a0426734.svg";